// src/services/BadgeService.js
//
// Which door badge belongs to which person.
//
// Neither system can answer this alone. Unifi identifies people by its own
// internal id; Entra has never heard of it. Somebody has to say which is which,
// and this is where that record lives.
//
// It sits in Vero rather than in an Entra extension attribute because those are
// invisible in the Entra portal: a wrong mapping could be neither seen nor
// corrected without Graph Explorer.

import apiClient from './apiClient'

export async function getBadgeMappings() {
  const response = await apiClient.post('/GetBadgeMappings', {})

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read badge mappings')
  }
  return response.data.mappings ?? []
}

export async function setBadgeMapping({ badgeUuid, entraObjectId, displayName, email }) {
  const response = await apiClient.post('/SetBadgeMapping', {
    badge_uuid: badgeUuid,
    entra_object_id: entraObjectId,
    display_name: displayName ?? '',
    email: email ?? ''
  })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not save the mapping')
  }
}

export async function deleteBadgeMapping(badgeUuid) {
  const response = await apiClient.post('/DeleteBadgeMapping', { badge_uuid: badgeUuid })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not remove the mapping')
  }
}
